import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map } from 'rxjs';
import { Global } from '../../shared/interfaces/cpe-interfaces.index';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GlobalService {
  private readonly http = inject(HttpClient);

  getGlobalByQuery(queryString?: string) {
    const query = queryString ? `?${queryString}` : '';
    return this.http
      .get<{ data: Global }>(`${environment.apiUrl}/global${query}`)
      .pipe(
        map(({ data }) => {
          if (!data?.navbar || !data?.footer) {
            throw new Error('navbar o footer no definidos');
          }

          return data;
        })
      );
  }
}
